const copy = {
  heading: 'How can we help you?',
  errors: {
    input: 'Please enter a search term.',
    search: 'Something went wrong with our search. Try again later.',
  },
  welcomeBanner: {
    nonPersonalizedSupport: {
      heading: 'Welcome to the new Twilio Help Center!',
      label:
        'The Help Center Assistant is coming soon - Click here to find all the details about our next launch.',
      articleId: '18133722687643',
    },
    personalizedSupport: {
      heading: 'Welcome to the new Twilio Help Center!',
      label:
        'The Help Center Assistant is coming soon - Click here to find all the details about our next launch.',
      articleId: '18459751718683',
    },
    endingPeriod: '.',
  },
};

export default copy;
